import React from 'react';
import type ProformaJiraExportType from '@atlassian/jira-spa-apps-proforma-export/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProformaExport = lazyForPaint<typeof ProformaJiraExportType>(
	() =>
		import(
			/* webpackChunkName: "async-proforma-export", jiraSpaEntry: "async-proforma-export" */ '@atlassian/jira-spa-apps-proforma-export'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyProformaExport} pageId="proforma-export" shouldShowSpinner />
);
